import MapeamentoRepository from './mapeamentoRepository';
import CompetenciaRepository from './competenciaRepository';
import CompetenciaTecnicaRepository from './competenciaTecnicaRepository';
import ComportamentoRepository from './comportamentoRepository';
import ResponsabilidadeRepository from './responsabilidadeRepository';
import DiagnosticoRepository from './diagnosticoRepository';
import DispensaDiagnosticoRepository from './dispensaDiagnosticoRepository';
import MotivoDispensaDiagnostico from './motivoDispensaDiagnosticoRepository';
import AvaliacaoRepository from './avaliacaoRepository';
import ItemAvaliacao from './itemAvaliacaoRepository';
import UsuarioRepository from './usuarioRepository';
import DesempenhoRepository from './desempenhoRepository';
import ArquivoRepository from './arquivoRepository';
import PerfilRepository from './perfilRepository';
import AreaCapacitacaoRepository from './areaCapacitacaoRepository';
import EscolaridadeRepository from './escolaridadeRepository';
import PerfilIdiomaRepository from './perfilIdiomaRepository';
import CursoCapacitacaoRepository from './cursoCapacitacaoRepository';
import CursoInstrutorRepository from './cursoInstrutorRepository';
import ExperienciaProfissionalRepository from './experienciaProfissionalRepository';
import ItemPreferenciaRepository from './itemPreferenciaRepository';
import PerfilPreferenciaRepository from './perfilPreferenciaRepository';
import TutorialRepository from './tutorialRepository';
import MonitoramentoRepository from './monitoramentoRepository';
import ResultadoResponsabilidadeRepository from './resultadoResponsabilidadeRepository';

const repositories = {
  mapeamento: MapeamentoRepository,
  competencia: CompetenciaRepository,
  competenciaTecnica: CompetenciaTecnicaRepository,
  comportamento: ComportamentoRepository,
  responsabilidade: ResponsabilidadeRepository,
  diagnostico: DiagnosticoRepository,
  dispensaDiagnostico: DispensaDiagnosticoRepository,
  motivoDispensaDiagnostico: MotivoDispensaDiagnostico,
  avaliacao: AvaliacaoRepository,
  itemAvaliacao: ItemAvaliacao,
  usuario: UsuarioRepository,
  desempenho: DesempenhoRepository,
  arquivo: ArquivoRepository,
  perfil: PerfilRepository,
  areaCapacitacao: AreaCapacitacaoRepository,
  escolaridade: EscolaridadeRepository,
  perfilIdioma: PerfilIdiomaRepository,
  cursoCapacitacao: CursoCapacitacaoRepository,
  cursoInstrutor: CursoInstrutorRepository,
  experienciaProfissional: ExperienciaProfissionalRepository,
  itemPreferencia: ItemPreferenciaRepository,
  perfilPreferencia: PerfilPreferenciaRepository,
  tutorial: TutorialRepository,
  monitoramento: MonitoramentoRepository,
  resultadoResponsabilidade: ResultadoResponsabilidadeRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
